import React from 'react';
import { CheckIcon } from 'lucide-react';
import { deliverables } from '../data/offer';
export function Deliverables() {
  return <div data-id="element-16" data-mp="10bw64zftv129">
      <p className="font-display text-lg font-bold uppercase tracking-wide text-bone" data-id="element-17" data-mp="10c5xorgitga2">
        ¿Qué te vas a llevar hoy?
      </p>
      <ul className="mt-4 space-y-2.5" data-id="element-18" data-mp="19b15g7z7qyfh">
        {deliverables.map(text => <li key={text} className="flex items-start gap-2.5 text-sm leading-snug text-bone/85" data-id="element-19" data-mp="198wqmuzs0f0f">
            <CheckIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-lime" data-id="element-20" data-mp="1o20872ddasr5" />
            {text}
          </li>)}
      </ul>
    </div>;
}